// extracted by mini-css-extract-plugin
export default {"body":"SuccessStep_body__XwEXy","infoHeader":"SuccessStep_infoHeader__EvdIB","icon":"SuccessStep_icon__WnXCG"};